export function createSettings(defaults = {}, overrides = {}) {
  const _settings = _updateSettingsFromDefinitions(defaults, overrides);
  _settings.has = (key) => _settings[key] !== undefined;
  return new Proxy(_settings, {
    get(target, name) {
      // This is simply to avoid a console error when using react development mode
      if (name === "$$typeof") {
        return null;
      }
      const value = target[name];
      if (value === undefined) {
        console.warn(`Unknown setting: ${String(name)}`);
      }
      return value;
    },
  });
}

function _updateSettingsFromDefinitions(defaults, overrides) {
  const settings: TODO = {};
  Object.keys(defaults).forEach((key) => {
    _setIfDefined(settings, key, defaults);
    _setIfDefined(settings, key, overrides);
    if (settings[key] !== undefined) {
      console.debug(`Setting defined: ${key}=${settings[key]}`);
    }
  });
  return settings;
}

function _setIfDefined(target, key, source) {
  const override = source[key];
  if (override !== undefined) {
    target[key] = override;
  }
}
